import {
  Box, Text,
} from '@domain-group/suit-theme'

import usePublication from '@hooks/usePublication'

import PublicationLogo from '@components/PublicationLogo'

import type { PublicationModel } from '@models/types'

interface PublicationTileProps {
  callbacks: {
    selectPublication: VoidFunction,
  },
  publication: PublicationModel,
}

const PublicationTile = (props: PublicationTileProps) => {
  const {
    callbacks: {
      selectPublication,
    },
    publication,
  } = props

  const publicationPayload = usePublication(publication)
  const {
    publication: {
      title,
    },
  } = publicationPayload

  return (
    <Box
      alignItems="center"
      as="a"
      border="1px solid"
      borderColor="lineColor"
      borderRadius="5px"
      height={84}
      marginBottom="medium"
      onClick={() => selectPublication()}
      padding="medium"
      style={{ cursor: 'pointer' }}
    >
      <PublicationLogo
        boxProps={{
          border: 'none',
        }}
        publication={publication}
      />

      <Box
        borderLeft="1px solid"
        borderColor="lineColor"
        flexDirection="column"
        marginLeft="medium"
        paddingLeft="large"
        paddingY="large"
        width="auto"
      >
        <Text fontSize="small">{title}</Text>
      </Box>
    </Box>
  )
}

export default PublicationTile
